"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanType = void 0;
const actual_type_1 = require("./actual-type");
const caster_cache_1 = require("./caster-cache");
function booleanType(declaration, validateOptions, circularCache = caster_cache_1.createCache()) {
    if (declaration === null || typeof declaration !== 'object') {
        throw new Error('First argument (declaration) must be an Object.');
    }
    const circularCaster = circularCache.get(declaration);
    if (circularCaster !== undefined) {
        return circularCaster;
    }
    const { type, required, strict } = declaration;
    if (type !== 'Boolean') {
        throw new Error('"type" property on declaration must be "Boolean"');
    }
    if (required !== undefined && typeof required !== 'boolean') {
        throw new Error('"required" property on declaration must be undefined or a Boolean');
    }
    if (strict !== undefined && typeof strict !== 'boolean') {
        throw new Error('"strict" property on declaration must be undefined or a Boolean');
    }
    const defaultCandidate = Reflect.get(declaration, 'default');
    if (defaultCandidate !== undefined && typeof defaultCandidate !== 'boolean') {
        throw new Error('"default" property on declaration must be undefined or a Boolean');
    }
    let caster = (candidate) => ({ type, isValid: true, invalidations: [], candidate });
    const options = Array.isArray(declaration.options) ? Array.from(declaration.options) : declaration.options;
    if (options !== undefined) {
        if (Array.isArray(options) === false || options.find((opt) => typeof opt !== 'boolean') !== undefined) {
            throw new Error('"options" property on declaration must undefined or an array of Boolean');
        }
        const casterRef = caster;
        caster = (candidate) => {
            const result = casterRef(candidate);
            if (options.find((opt) => opt === candidate) === undefined) {
                return {
                    ...result,
                    invalidations: [[[], 'Boolean', 'options', options, candidate], ...result.invalidations]
                };
            }
            return result;
        };
    }
    const casterRef = (candidate) => {
        const originalCandidate = candidate;
        if (strict === false && typeof candidate === 'string' && candidate.trim().length === 0) {
            candidate = undefined;
        }
        if ((candidate === undefined || candidate === null) && defaultCandidate !== undefined) {
            candidate = defaultCandidate;
        }
        if (candidate === undefined || candidate === null) {
            if (required === false) {
                return {
                    type,
                    isValid: true,
                    invalidations: [],
                    undefined
                };
            }
            else {
                return {
                    type,
                    isValid: false,
                    candidate,
                    invalidations: [[[], 'Boolean', 'required', true, candidate]]
                };
            }
        }
        if (strict === false) {
            if (typeof candidate === 'number') {
                if (candidate === 1) {
                    candidate = true;
                }
                else if (candidate === 0) {
                    candidate = false;
                }
            }
            else if (typeof candidate === 'string') {
                switch (candidate) {
                    case '1':
                    case 't':
                    case 'T':
                    case 'true':
                    case 'True':
                    case 'TRUE':
                        candidate = true;
                        break;
                    case '0':
                    case 'f':
                    case 'F':
                    case 'false':
                    case 'False':
                    case 'FALSE':
                        candidate = false;
                        break;
                }
            }
        }
        const candidateType = actual_type_1.ctorName(candidate);
        if (candidateType !== type) {
            return {
                type,
                isValid: false,
                candidate,
                invalidations: [[[], 'Boolean', 'type', type, candidateType]]
            };
        }
        const result = caster(candidate);
        const isValid = result.invalidations.length === 0;
        return {
            ...result,
            isValid,
            candidate: isValid ? candidate : originalCandidate
        };
    };
    return circularCache.set(declaration, casterRef);
}
exports.booleanType = booleanType;
